import { z } from 'zod'; // Add new import

export const OrdersSchedulesSchema = z
  .object({
    id: z.number().nullable().optional(),
    startMonth: z.number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    }),
    endMonth: z.number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    }),
    year: z.number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    }),
  })
  .refine((data) => data.startMonth <= data.endMonth, {
    message: 'endDateLessThanStartDate',
    path: ['endMonth'],
  });
